/**
 * Mapeo PURO: contextos de vehículo de un accidente (snapshot
 * `VehicleAccidentContext`) → filas de la tabla "Vehicles implicats" del informe.
 *
 * Vive fuera de `fetchReportData.ts` (que arrastra Apollo e i18n) para poder
 * testearse sin navegador, igual que `combinedSort.ts`.
 *
 * Etiquetado: los vehículos principales reciben letra (A, B, C…) y sus remolques
 * la letra del padre + índice (A1, A2, B1…).
 */

export type VehicleAccidentContextLike = {
  id: string;
  plate?: string | null;
  model?: string | null;
  color?: string | null;
  insurance?: string | null;
  policyNumber?: string | null;
  numberOccupants?: number | null;
  parentVehicleContextId?: string | null;
};

export type VehicleInvolvedRow = {
  vehicle: string;
  plate: string;
  color: string;
  model: string;
  insurance: string;
  policyNumber: string;
  occupants: string;
};

const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

function toRow(
  ctx: VehicleAccidentContextLike,
  label: string
): VehicleInvolvedRow {
  return {
    vehicle: label,
    plate: ctx.plate ?? '',
    color: ctx.color ?? '',
    model: ctx.model ?? '',
    insurance: ctx.insurance ?? '',
    policyNumber: ctx.policyNumber ?? '',
    occupants: ctx.numberOccupants != null ? String(ctx.numberOccupants) : '-',
  };
}

export function buildVehiclesInvolved(
  contexts: VehicleAccidentContextLike[] = []
): VehicleInvolvedRow[] {
  const rows: VehicleInvolvedRow[] = [];
  const parents = contexts.filter((ctx) => !ctx.parentVehicleContextId);

  parents.forEach((parent, idx) => {
    const letter = LETTERS[idx] ?? String(idx + 1);
    rows.push(toRow(parent, letter));

    contexts
      .filter((ctx) => ctx.parentVehicleContextId === parent.id)
      .forEach((trailer, tIdx) =>
        rows.push(toRow(trailer, `${letter}${tIdx + 1}`))
      );
  });

  return rows;
}
